export default "__VITE_ASSET__DFENnlYy__"